import React, { Component } from "react";

import autobind from "react-autobind";

import { Field, Form, Formik } from "formik";

import { FormGroup, Label, Button, Spinner } from "reactstrap";

import { SelectInput } from "@gsd/backoffice-ui";

import * as Yup from "yup";

const ValidateSchema = Yup.object().shape({
  uidApplication: Yup.number().required("Campo obbligatorio"),
  uidRole: Yup.number().required("Campo obbligatorio")
});
interface FormModel {
  uidApplication: number,
  uidRole: number,
  acls: Array<number>
}
type FormProps = {
    onSubmit: (values: FormModel) => Promise<any> | void,
    initialValues: FormModel,
    options: {
        optsApplications: Array<{ value: string, lable: string }>,
        optsRoles: Array<{ value: string, lable: string }>,
        optsAcls: Array<{ value: string, lable: string }>
    },
    onCancel: Function,
    onChangeAppUid: Function,
    readOnly: boolean
};

type FormState = {
    formValues: {
        uidApplication: number,
        uidRole: number,
        acls: Array<number>
    }
};

export default class FormUserPerission extends Component<FormProps, FormState> {
  constructor(props: FormProps) {
    super(props);
    autobind(this);
  }

  _onChangeApp = async (form, fieldName, fieldValue) => {
    this.props.onChangeAppUid(fieldValue);
  };

  render() {
    const {
      onCancel,
      readOnly,
      initialValues,
      options: { optsApplications, optsRoles, optsAcls }
    } = this.props;
    console.log("FORM USER RENDER", this.props.options);
    return (
      <Formik
        initialValues={initialValues}
        validationSchema={ValidateSchema}
        validateOnBlur
        onSubmit={this.props.onSubmit}
        enableReinitialize={true}
        isInitialValid={true}
      >
        {(formmikProps) => {
          if (formmikProps.isSubmitting) {
            return (
              <div className="text-center animated fadeIn">
                <Spinner style={{ width: "5rem", height: "5rem" }} color="primary" />
              </div>
            );
          }
          return (
            <Form>
              <FormGroup>
                <Label for="uidApplication">Applicazione</Label>
                <Field
                  name="uidApplication"
                  options={optsApplications}
                  component={SelectInput}
                  setDependencies={this._onChangeApp}
                  disabled={readOnly}
                />
              </FormGroup>
              <FormGroup>
                <Label for="uidRole">Ruolo</Label>
                <Field name="uidRole" options={optsRoles} component={SelectInput} disabled={readOnly} />
              </FormGroup>
              <FormGroup>
                <Label for="acls">ACLs</Label>
                <Field name="acls" options={optsAcls} isMulti component={SelectInput} />
              </FormGroup>
              <div className="d-flex justify-content-between">
                <Button color="primary" className="px-5" type="submit" disabled={!formmikProps.isValid || formmikProps.isSubmitting}>
                                    Salva
                </Button>
                <Button type="button" className="px-5" onClick={onCancel}>
                                    Annulla
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  }
}
